import { useFormik } from 'formik';
import * as Yup from 'yup';
import React from 'react';
import { UseApi } from '../../libraries/UseApi';
import { Box, Flex, Heading, Stack } from '@chakra-ui/react';
import CustomInput from '../../components/form-components/CustomInput';
import SubmitButton from '../../components/custom/SubmitButton';
import LinkButton from '../../components/custom/LinkButton';

export default function AddSkill() {
    const { postApi } = UseApi();

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid Email Address').required('Email is required'),
            password: Yup.string().required('Password is required'),
        }),
        onSubmit: (values) => {
            postApi(
                `${process.env.REACT_APP_API_URL}/user/login`, values, {},
                (response) => {
                    // レスポンスチェック
                    if (response.isSuccess === false) {
                        // 入力内容を確認してください。
                        //alert(Message.Common.CONFIRM_INPUT);
                        return;
                    }
                    //handleSignInResponse(response);
                    // ワンタイムパスワード切替
                    //setAdminLoginMode(EnumScreenMode.COMPLATE);
                }
            );
        }
    });

    const AddForm = () => {
        return (
            <form onSubmit={formik.handleSubmit}>
                <Stack spacing={4}>
                    <CustomInput
                        formik={formik}
                        label={'Email address'}
                        type={'email'}
                        name={'email'}
                        id={'email'}
                        placeholder={'Enter Email Address'}
                        required={true}
                    />
                    <CustomInput
                        formik={formik}
                        label={'Password'}
                        type={'password'}
                        name={'password'}
                        id={'password'}
                        placeholder={'Enter Password'}
                        required={true}
                    />
                    <Stack spacing={10}>
                        <Flex gap={2}>
                            <SubmitButton buttonText={'Submit'} />
                            <LinkButton buttonText={'Back'} buttonUrl={'#'} />
                        </Flex>
                    </Stack>
                </Stack>
            </form>
        );
    }

    return (
        <>
            <Heading as='h2' size='2xl' noOfLines={1} mb={5}>
                Add Skill
            </Heading>
            <Box className='admin-box'>
                <AddForm />
            </Box>
        </>   
    )
}
